import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgBluetooth = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M10.5 2c0-.83.943-1.284 1.587-.81l.086.07 5.5 5a1 1 0 0 1 .1 1.374l-.083.09-4.48 4.275 4.48 4.278a1 1 0 0 1 .068 1.375l-.085.088-5.5 5c-.615.559-1.584.166-1.667-.63L10.5 22v-7.414l-3.81 3.637a1 1 0 0 1-1.321.053l-.092-.086a1 1 0 0 1-.053-1.321l.086-.092L10.313 12 5.31 7.223a1 1 0 0 1-.114-1.317l.08-.096a1 1 0 0 1 1.318-.114l.096.08 3.81 3.637V2Zm2 12.087v5.652l3.033-2.757-3.033-2.895Zm0-9.827v5.652l3.033-2.895L12.5 4.26Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgBluetooth)
const Memo = memo(ForwardRef)
export default Memo
